import { gql } from "@apollo/client"

export const DeleteWorker = gql`
mutation DeleteWorker($deleteWorkerId: ID!) {
  deleteWorker(id: $deleteWorkerId) {
    status
  }
}
`